import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IdType } from 'src/app/shared/enums/IdType.enum';

@Component({
  selector: 'app-investor-complete-profile-dialog',
  templateUrl: './investor-complete-profile-dialog.component.html',
  styleUrls: ['./investor-complete-profile-dialog.component.scss'],
})
export class InvestorCompleteProfileComponent implements OnInit {
  @Input() idType: IdType = IdType['National ID'];

  get isJuridico(): boolean {
    return this.idType === IdType.RUC;
  }
  
  constructor(public dialogRefModal: MatDialogRef<InvestorCompleteProfileComponent>) {}

  ngOnInit(): void {}
}
